import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router'
import { Breadcrumbs } from '@/shared/ui/breadcrumbs'

const ReservationDetail = lazyRouteComponent(
  () => import('@/widgets/reservation-detail'),
  'ReservationDetail',
)

export const Route = createFileRoute('/capacity/$reservationId')({
  component: ReservationPage,
})

function ReservationPage() {
  const { reservationId } = Route.useParams()
  return (
    <>
      <Breadcrumbs current={reservationId} />
      <ReservationDetail reservationId={reservationId} />
    </>
  )
}
